<template>
  <div>
    <AirportItem
      v-for="item in list"
      :key="item.airportName"
      :item="item"
      :locale="locale" />
  </div>
</template>

<script>
import AirportItem from '@/components/FlightInfo/AirportItem.vue'

export default {
  props: [
    'locale',
    'list'
  ],
  components: {
    AirportItem
  }
}
</script>

<style lang="scss" scoped>
.cnt {
  margin-bottom: 0.5em;
  text-align: right;
}
.noData {
  padding: 120px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 64px;
    margin-bottom: 30px;
    background: url('~@/assets/img/ico_search.svg') 50% 50% / contain no-repeat;
    opacity: 0.2;
  }
}
</style>
